import { render, staticRenderFns } from "./ManuscriptList.vue?vue&type=template&id=b741b990&scoped=true"
import script from "./ManuscriptList.vue?vue&type=script&lang=ts"
export * from "./ManuscriptList.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptList.vue?vue&type=style&index=0&id=b741b990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b741b990",
  null
  
)

export default component.exports